module.exports = __webpack_public_path__ + "static/img/浙商银行@2x.2359f1aa.png";